import { Suspense, type ReactNode } from "react";
import { ErrorBoundary } from "react-error-boundary";
import { Notification } from "@/components/admin/notification";
import { Error } from "@/components/admin/error";
import { Skeleton } from "@/components/ui/skeleton";

import { DataImportProvider } from "../dataImport/DataImportProvider";
import { useConfigurationLoader } from "../root/useConfigurationLoader";
import Header from "./Header";
import { Sidebar } from "./Sidebar";
import { useSidebarExpanded } from "./useSidebarExpanded";

export const Layout = ({ children }: { children: ReactNode }) => {
  useConfigurationLoader();
  const [sidebarExpanded] = useSidebarExpanded();
  return (
    <DataImportProvider>
      <Sidebar />
      <div
        className={`flex min-h-screen flex-col transition-[padding] ${sidebarExpanded ? "md:pl-64" : "md:pl-16"}`}
      >
        <Header />
        <main className="mx-auto w-full max-w-screen-2xl p-4" id="main-content">
          <ErrorBoundary FallbackComponent={Error}>
            <Suspense
              fallback={<Skeleton className="h-12 w-12 rounded-full" />}
            >
              {children}
            </Suspense>
          </ErrorBoundary>
        </main>
      </div>
      <Notification />
    </DataImportProvider>
  );
};
